import { render } from "./people-contacts.vue?vue&type=template&id=726a9945"
import script from "./people-contacts.vue?vue&type=script&lang=js"
export * from "./people-contacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__